"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDailyPriceFieldFiltering = void 0;
var RentalPriceType_1 = require("../../types/SearchPage/RentalPriceType");
var RentalPriceTypes_1 = require("../../constants/SearchPageCategories/RentalPriceTypes");
var PropertyTypes_1 = require("../../constants/SearchPageCategories/PropertyTypes");
var StructureTypes_1 = require("../../constants/SearchPageCategories/StructureTypes");
var RoomWithPropertyAndStructureType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyAndStructureType");
var RoomWithPropertyType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyType");
var makeDailyPriceFieldFiltering = function (value, propertyTypeQuery, isDeveloperQuery, currentLanguage, roomsQuery, structureTypeQuery, rentalPrizeQuery, setRentalPrizeQuery, replacePageURL) {
    if (value === rentalPrizeQuery[0] &&
        rentalPrizeQuery[0] === RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.RENTAL_PRIZE_TYPE) {
        setRentalPrizeQuery([]);
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !isDeveloperQuery.length &&
            !roomsQuery.length &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(PropertyTypes_1.PROPERTY_TYPES[currentLanguage].rent[propertyTypeQuery[0]]);
        }
        if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            propertyTypeQuery.length &&
            !isDeveloperQuery.length &&
            !roomsQuery.length) {
            replacePageURL(StructureTypes_1.STRUCTURE_TYPES[currentLanguage].rent[propertyTypeQuery[0]]);
        }
        if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            propertyTypeQuery.length &&
            !isDeveloperQuery.length &&
            roomsQuery.length) {
            replacePageURL(RoomWithPropertyAndStructureType_1.RoomWithPropertyAndStructureType[currentLanguage].rent[propertyTypeQuery[0]][roomsQuery[0]]);
        }
        if (propertyTypeQuery.length &&
            roomsQuery.length &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !isDeveloperQuery.length) {
            replacePageURL(RoomWithPropertyType_1.ROOM_WITH_PROPERTY_TYPE[currentLanguage][propertyTypeQuery[0]][roomsQuery[0]]);
        }
    }
    else if (value === RentalPriceType_1.RENTAL_DAILY_PRICE_TYPE.RENTAL_PRIZE_TYPE) {
        setRentalPrizeQuery([value]);
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !isDeveloperQuery.length &&
            !roomsQuery.length &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent.WITH_PROPERTY_TYPE[propertyTypeQuery[0]]);
        }
        if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            propertyTypeQuery.length &&
            !isDeveloperQuery.length &&
            !roomsQuery.length) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent
                .WITH_PROPERTY_STRUCTURE_TYPE[propertyTypeQuery[0]]);
        }
        if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            propertyTypeQuery.length &&
            !isDeveloperQuery.length &&
            roomsQuery.length) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent
                .WITH_ROOM_PROPERTY_STRUCTURE_TYPE[propertyTypeQuery[0]][roomsQuery[0]]);
        }
        if (propertyTypeQuery.length &&
            roomsQuery.length &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !isDeveloperQuery.length) {
            replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage].rent.WITH_ROOM_PROPERTY_TYPE[propertyTypeQuery[0]][roomsQuery[0]]);
        }
    }
};
exports.makeDailyPriceFieldFiltering = makeDailyPriceFieldFiltering;
